import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import wlGantt from 'wl-gantt'

import "wl-gantt/lib/wl-gantt.css"

Vue.use(wlGantt)
Vue.use(ElementUI);

import VueCookie from "vue-cookie";
import globalCmpPlugin from "@/plugins/globalCmp";
Vue.use(globalCmpPlugin);
import globalMixin from "@/plugins/globalMixin";
Vue.use(globalMixin); 

import 'babel-polyfill'
Vue.prototype.$http = httpRequest // ajax请求方法
import bus from "@/utils/bus.js";
import '@/utils/rem.js'
Vue.prototype.$bus = bus;
import { getProductAmountPriceAllDx,generateUUID,preciseAdd,isWorkDays,getYMD,handlePriceInput } from '@/utils/numberTools'
import '@/styles/index.scss'
Vue.prototype.getProductAmountPriceAllDx = getProductAmountPriceAllDx;
Vue.prototype.generateUUID = generateUUID;
Vue.prototype.preciseAdd = preciseAdd;
Vue.prototype.isWorkDays = isWorkDays;
Vue.prototype.getYMD = getYMD;
Vue.prototype.loginToken = VueCookie.get('token');

import { getColumnWidth } from './utils/el_table'
Vue.prototype.$getColumnWidth = getColumnWidth;
Vue.prototype.handlePriceInput = handlePriceInput;

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js